module.exports = __webpack_public_path__ + "img/23.problem_door.6ccf5f01.svg";